// The PIN typed on this phone, kept so the Status App lets itself in again if its year-long access cookie is ever
// lost (Viktor, 16 Oct 2026: "when user has entered the pin save it in localstorage so he does not always need to
// enter it again"). Logging out forgets it, and so does a saved PIN the server no longer accepts. The admin PIN asked
// for before adding a user or opening the admin pages is never kept: it is asked for each time on purpose.
const KEY = "soulcake.status.pin";

export function savedPin(): string | null {
  try { return localStorage.getItem(KEY); } catch { return null; }
}
export function savePin(pin: string): void {
  try { localStorage.setItem(KEY, pin); } catch { /* not kept */ }
}
export function forgetPin(): void {
  try { localStorage.removeItem(KEY); } catch { /* nothing kept */ }
}
